import { render, staticRenderFns } from "./withdrawalSuccessful.vue?vue&type=template&id=70ec97d6&scoped=true"
import script from "./withdrawalSuccessful.vue?vue&type=script&lang=js"
export * from "./withdrawalSuccessful.vue?vue&type=script&lang=js"
import style0 from "./withdrawalSuccessful.vue?vue&type=style&index=0&id=70ec97d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec97d6",
  null
  
)

export default component.exports